import _extends from "@babel/runtime-corejs3/helpers/extends";import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";function ownKeys(object, enumerableOnly) {var keys = _Object$keys(object);if (_Object$getOwnPropertySymbols) {var symbols = _Object$getOwnPropertySymbols(object);enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {return _Object$getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));});}return target;}import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";import clsx from 'clsx';
import React from 'react';
import {



MilestoneStatuses,
MilestonesVisualTypes } from "../../types/Milestones";

import MilestoneItem from "./MilestoneItem";
import { createStyles } from "./styles";

export function determineOneMilestoneStatus(
milestone,
currentMilestoneIdx,
lastActiveOrCompletedMilestoneIdx)
{
  // Checks if status is presented.
  if (milestone.status) {var _context;
    // Checks if the status field has a valid value and assign it if so, otherwise assign default 'inactive' status.
    return _includesInstanceProperty(_context = _Object$values(MilestoneStatuses)).call(_context, milestone.status) ?
    milestone.status :
    MilestoneStatuses.INACTIVE;
  }
  // Checks if there is an active or completed milestone ahead and if so - set 'completed' value to the current milestone.
  if (currentMilestoneIdx < lastActiveOrCompletedMilestoneIdx) {
    return MilestoneStatuses.COMPLETED;
  }
  return MilestoneStatuses.INACTIVE;
}

export function getMilestonesWithDefaultStatuses(
rawMilestones)
{
  var lastActiveOrCompletedMilestoneIdx = -1;
  rawMilestones.forEach(function (rawMilestone) {
    if (
    rawMilestone.status === MilestoneStatuses.ACTIVE ||
    rawMilestone.status === MilestoneStatuses.COMPLETED)
    {
      lastActiveOrCompletedMilestoneIdx = rawMilestones.indexOf(rawMilestone);
    }
  });

  return lastActiveOrCompletedMilestoneIdx < 0 ?
  rawMilestones :
  _mapInstanceProperty(rawMilestones).call(rawMilestones, function (rawMilestone) {
    return _objectSpread(_objectSpread({},
    rawMilestone), {}, {
      status: determineOneMilestoneStatus(
      rawMilestone,
      rawMilestones.indexOf(rawMilestone),
      lastActiveOrCompletedMilestoneIdx) });


  });
}
/**
 * The component may have any number of items. The properties of each item are displayed at the bottom of this page.
 * Each component has a 'status' property which could have 'inactive', 'active' or 'completed value'. By default the
 * Milestone component search for the last item in its list that has either 'active' or 'completed' value and sets
 * all the antecedent items statuses to 'completed'. The status of each item may be overridden by specifying it in
 * the corresponding item in the 'milestoneItems'.
 */
var Milestones = function Milestones(props) {var _context2;
  var _props$visualType =




    props.visualType,visualType = _props$visualType === void 0 ? MilestonesVisualTypes.VERTICAL : _props$visualType,milestones = props.milestones,_props$allConnectingL = props.allConnectingLinesWidth,allConnectingLinesWidth = _props$allConnectingL === void 0 ? '6.8rem' : _props$allConnectingL,className = props.className;

  var classes = createStyles(props);
  return /*#__PURE__*/(
    React.createElement("ul", { className: clsx(classes.milestones, classes[visualType], className) },
    _mapInstanceProperty(_context2 = getMilestonesWithDefaultStatuses(milestones)).call(_context2, function (milestone) {
      var milestoneItemProps = _objectSpread(_objectSpread({},
      milestone), {}, {
        connectingLineWidth: milestone.connectingLineWidth || allConnectingLinesWidth,
        visualType: visualType });

      return /*#__PURE__*/React.createElement(MilestoneItem, _extends({}, milestoneItemProps, { key: "".concat(milestone.label) }));
    })));


};

export default Milestones;
//# sourceMappingURL=index.js.map